module.exports = __webpack_public_path__ + "media/images/icons/gdpr_proof-4b1900b5d28f58712a0245e4ab63c6c5.svg";